import axios from 'axios';

const API_BASE = '/api/time-off-requests';

export const timeOffRequestService = {
  listMine: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/mine`, { params });
    return response.data;
  },

  listUnseenDecisions: async () => {
    const response = await axios.get(`${API_BASE}/mine/unseen-decisions`);
    return response.data;
  },

  markDecisionsSeen: async () => {
    const response = await axios.post(`${API_BASE}/mine/mark-seen`);
    return response.data;
  },

  createMine: async (body) => {
    const response = await axios.post(`${API_BASE}/mine`, body);
    return response.data;
  },

  cancelMine: async (id) => {
    const response = await axios.post(`${API_BASE}/mine/${id}/cancel`);
    return response.data;
  },

  getPendingCount: async () => {
    const response = await axios.get(`${API_BASE}/pending-count`);
    return response.data;
  },

  list: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },

  review: async (id, body) => {
    const response = await axios.patch(`${API_BASE}/${id}`, body);
    return response.data;
  },

  getCalendar: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/calendar`, { params });
    return response.data;
  },

  delete: async (id) => {
    const response = await axios.delete(`${API_BASE}/${id}`);
    return response.data;
  }
};
